import { apiSlice } from ".";

// LatestCoordinates may be {lat,lng} / {latitude,longitude} or a "lat,lng" string.
const parseCoords = (c) => {
  if (!c) return {};
  if (typeof c === "string") {
    const [lat, lng] = c.split(",").map((v) => parseFloat(v));
    return { lat, lng };
  }
  return {
    lat: Number(c.lat ?? c.latitude),
    lng: Number(c.lng ?? c.lon ?? c.longitude),
  };
};

// Map the REST row (agentid / LatestCoordinates / LastTrackedAt) to the SignalR payload shape.
const normalizeRow = (row) => ({
  ...row,
  agentId: row.agentId ?? row.agentid,
  ...parseCoords(row.LatestCoordinates),
  lastUpdate: row.lastUpdate ?? row.LastTrackedAt ?? null,
});

export const agentLocationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Initial snapshot of every agent's latest position. Live changes arrive over SignalR.
    getLiveAgentLocations: builder.query({
      query: (agencyId) => `api/agentlocation/live?agencyId=${agencyId}`,
      // Endpoint may wrap the list in an envelope; always hand back an array.
      transformResponse: (res) => {
        if (Array.isArray(res)) return res;
        const list = res?.data ?? res?.result ?? res?.agents ?? res?.items;
        if (!Array.isArray(list)) console.warn("Unexpected agent locations response", res);
        return (Array.isArray(list) ? list : []).map(normalizeRow);
      },
    }),
    getLiveAgentLocation: builder.query({
      query: (agentId) => `api/agentlocation/live/${agentId}`,
    }),
    getAgentLocationHistory: builder.query({
      query: ({ agentId, from, to, maxPoints = 1000 }) => ({
        url: "api/agentlocation/history",
        params: { agentId, from, to, maxPoints },
      }),
    }),
    getAgentLocationSummary: builder.query({
      query: ({ agencyId, date }) => ({
        url: "api/agentlocation/history/summary",
        params: { agencyId, date },
      }),
    }),
  }),
});

export const {
  useGetLiveAgentLocationsQuery,
  useGetLiveAgentLocationQuery,
  useGetAgentLocationHistoryQuery,
  useGetAgentLocationSummaryQuery,
} = agentLocationApi;
